var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shortcut-board"},_vm._l((_vm.displayShortcutRows),function(row,rowIndex){return _c('div',{key:rowIndex,staticClass:"row"},_vm._l((row),function(item){return _c('button',{key:item.key,staticClass:"btn",class:[
      item.sizeClass,
      item.bgClass,
      { 'is-active': _vm.activeKey === item.key },
    ],attrs:{"type":"button","aria-label":item.ariaLabel || item.label},on:{"click":function($event){return _vm.handleShortcutClick(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }